/**
 * Browser helpers for session-bound double-submit CSRF (`adieuu_csrf` cookie
 * → `X-CSRF-Token` header). Used by ApiClient and raw `fetch` callers that
 * cannot go through ApiClient (e.g. crash reporting).
 */
export const CSRF_COOKIE_NAME = 'adieuu_csrf';
export const CSRF_HEADER_NAME = 'X-CSRF-Token';
/** Reads `adieuu_csrf` from `document.cookie` when available. */
export function readCsrfCookie() {
    if (typeof document === 'undefined' || !document.cookie) {
        return undefined;
    }
    const prefix = `${CSRF_COOKIE_NAME}=`;
    for (const part of document.cookie.split(';')) {
        const trimmed = part.trim();
        if (trimmed.startsWith(prefix)) {
            return trimmed.substring(prefix.length);
        }
    }
    return undefined;
}
/**
 * Returns headers that attach `X-CSRF-Token` when the CSRF cookie is present.
 * Safe to spread into any mutating request's headers object.
 */
export function csrfHeaders() {
    const token = readCsrfCookie();
    return token ? { [CSRF_HEADER_NAME]: token } : {};
}
//# sourceMappingURL=csrf.js.map